/**
 * STICKY ADD TO CART — barre mobile « façon Ernest Leoty »
 * --------------------------------------------------------
 * Enrichit la barre sticky native de la fiche produit (snippet
 * product-sticky-add-to-cart.liquid) :
 *
 *  - Pastille « Taille » -> ouvre un tiroir bas « Choisir une taille »
 *    (réutilise l'élément global #CardSizeSheet + son CSS / ses handlers de
 *    fermeture déjà fournis par card-size-sheet.js).
 *  - Garde-fou CRO : taper « Ajouter au panier » sans avoir choisi sa taille
 *    ouvre le tiroir au lieu d'ajouter la taille par défaut.
 *  - La sélection d'une taille pilote le <variant-picker> natif (clic sur la
 *    vraie radio) -> le thème met à jour prix, galerie et input[name="id"].
 *  - L'ajout au panier réutilise le <product-form> natif -> ouverture du
 *    cart-drawer gérée par le thème.
 *
 * 100% écoute déléguée (le contenu du <product-rerender> est recréé à chaque
 * changement de variante : aucun listener ne doit y être attaché directement).
 */
(function () {
  if (window.__stickyCartInit) return;
  window.__stickyCartInit = true;

  var cssEscape = function (s) {
    return window.CSS && CSS.escape ? CSS.escape(s) : s;
  };
  var isMobile = function () {
    return window.matchMedia('(max-width: 699px)').matches;
  };

  function sticky() {
    return document.querySelector('.product-sticky-add-to-cart');
  }

  // <variant-picker> lié au même formulaire que la barre sticky
  function mainPicker() {
    var st = sticky();
    var formId = st && st.getAttribute('main-product-form');
    if (formId) {
      var p = document.querySelector('variant-picker[form-id="' + cssEscape(formId) + '"]');
      if (p) return p;
    }
    return document.querySelector('variant-picker');
  }

  // Radios de l'option « Taille » : modèle 1 produit = 1 couleur, donc la Taille
  // est le groupe d'option qui porte le plus de valeurs.
  function sizeRadios() {
    var picker = mainPicker();
    if (!picker) return [];
    var radios = Array.prototype.slice.call(
      picker.querySelectorAll('input[type="radio"][data-option-position]')
    );
    var byPos = {};
    radios.forEach(function (r) {
      var p = r.getAttribute('data-option-position');
      (byPos[p] = byPos[p] || []).push(r);
    });
    var best = [];
    Object.keys(byPos).forEach(function (p) {
      if (byPos[p].length > best.length) best = byPos[p];
    });
    return best;
  }

  function labelFor(radio) {
    var picker = mainPicker();
    var lbl = picker && picker.querySelector('label[for="' + cssEscape(radio.id) + '"]');
    return lbl ? lbl.textContent.trim() : (radio.value || '');
  }

  function isAvailable(radio) {
    if (radio.disabled) return false;
    var picker = mainPicker();
    var lbl = picker && picker.querySelector('label[for="' + cssEscape(radio.id) + '"]');
    if (lbl && lbl.classList.contains('is-disabled')) return false;
    return true;
  }

  var userPicked = false;

  function updateChip(text) {
    var el = document.querySelector('[data-sticky-size-label]');
    if (el && text) el.textContent = text;
  }

  /* ---- Tiroir « Choisir une taille » (réutilise #CardSizeSheet) ---- */

  function buildSheet(mode) {
    var sheet = document.getElementById('CardSizeSheet');
    if (!sheet) return null;

    // En-tête « aminci » : depuis le sticky fiche produit, on n'affiche NI la
    // photo NI le prix (on est déjà sur le produit) -> tiroir plus fin. La photo
    // et le prix restent affichés pour l'achat express en page collection.
    sheet.classList.add('card-size-sheet--bare');

    // Tailles
    var wrap = sheet.querySelector('[data-card-sheet-sizes]');
    if (!wrap) return null;
    wrap.innerHTML = '';
    sizeRadios().forEach(function (radio) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'button floating-size-selector__button' + (isAvailable(radio) ? '' : ' is-disabled');
      btn.textContent = labelFor(radio);
      btn.setAttribute('data-sticky-size-value', radio.id);
      if (radio.checked && userPicked) btn.setAttribute('aria-current', 'true');
      wrap.appendChild(btn);
    });

    sheet.setAttribute('data-sticky-mode', mode || 'select');
    return sheet;
  }

  function openSheet(mode) {
    var sheet = buildSheet(mode);
    if (!sheet) return;
    sheet.hidden = false;
    requestAnimationFrame(function () {
      sheet.classList.add('is-open');
    });
    document.documentElement.classList.add('card-size-sheet-open');
  }

  function closeSheet() {
    var sheet = document.getElementById('CardSizeSheet');
    if (!sheet || sheet.hidden) return;
    sheet.removeAttribute('data-sticky-mode');
    sheet.classList.remove('is-open', 'card-size-sheet--bare');
    document.documentElement.classList.remove('card-size-sheet-open');
    var done = function () {
      if (!sheet.classList.contains('is-open')) sheet.hidden = true;
      sheet.removeEventListener('transitionend', done);
    };
    sheet.addEventListener('transitionend', done);
    setTimeout(done, 350);
  }

  /* ---- Sélection de taille + ajout panier (mécanismes natifs) ---- */

  function selectSize(radioId) {
    var picker = mainPicker();
    var radio = picker && picker.querySelector('#' + cssEscape(radioId));
    if (!radio || radio.disabled) return false;
    userPicked = true;
    if (!radio.checked) {
      radio.click(); // déclenche le change natif du <variant-picker>
    }
    updateChip(labelFor(radio));
    return true;
  }

  function nativeAdd() {
    var st = sticky();
    var formId = st && st.getAttribute('main-product-form');
    requestAnimationFrame(function () {
      // On vise le formulaire produit PRINCIPAL (évite un éventuel <buy-buttons>
      // de quick-buy présent ailleurs sur la page).
      var scoped =
        formId && document.querySelector('buy-buttons[form="' + cssEscape(formId) + '"] button[type="submit"]');
      var btn = scoped || document.querySelector('buy-buttons button[type="submit"]');
      if (btn) {
        btn.click();
      } else if (formId) {
        var form = document.getElementById(formId);
        if (form && form.requestSubmit) form.requestSubmit();
      }
    });
  }

  /* ---- Écoute déléguée ---- */

  // En capture pour pouvoir bloquer la soumission du bouton ATC mobile.
  document.addEventListener(
    'click',
    function (e) {
      if (!sticky() || !e.target.closest) return;

      // Ouvrir le sélecteur depuis la pastille « Taille »
      var trig = e.target.closest('[data-sticky-size-trigger]');
      if (trig) {
        e.preventDefault();
        openSheet('add'); // tap sur une taille = ajout direct (comme l'achat express)
        return;
      }

      // Garde-fou : ATC mobile sans taille choisie -> ouvrir le sélecteur
      var add = e.target.closest('.sticky-atc-mobile__add');
      if (add && isMobile() && sizeRadios().length > 1 && !userPicked) {
        e.preventDefault();
        e.stopPropagation();
        openSheet('add');
        return;
      }

      // Choix d'une taille dans le tiroir
      var sizeBtn = e.target.closest('[data-sticky-size-value]');
      if (sizeBtn && !sizeBtn.classList.contains('is-disabled')) {
        var sheet = document.getElementById('CardSizeSheet');
        var mode = sheet ? sheet.getAttribute('data-sticky-mode') : 'select';
        var ok = selectSize(sizeBtn.getAttribute('data-sticky-size-value'));
        closeSheet();
        if (ok && mode === 'add') nativeAdd();
        return;
      }
    },
    true
  );

  // Choix de taille via le sélecteur principal de la fiche -> on lève le garde-fou
  document.addEventListener(
    'change',
    function (e) {
      var picker = mainPicker();
      if (!picker || !picker.contains(e.target)) return;
      if (!e.target.matches('input[type="radio"][data-option-position]')) return;
      var ids = sizeRadios().map(function (r) {
        return r.id;
      });
      if (ids.indexOf(e.target.id) !== -1) {
        userPicked = true;
        updateChip(labelFor(e.target));
      }
    },
    true
  );

  // À l'ajout au panier, le cart-drawer prend le relais : on ferme le tiroir
  document.addEventListener('cart:change', closeSheet);

  /* ---- Visibilité (mobile) ----
   * La logique native (SandwichVisibility) n'affiche la barre qu'une fois le
   * formulaire produit passé AU-DESSUS du viewport. On veut, sur mobile, que la
   * barre soit visible dès que le vrai CTA n'est PAS visible (au-dessus comme en
   * dessous) et masquée quand on le voit. On pilote donc une classe dédiée
   * (.sticky-cta-out) qui prime en CSS ; le desktop garde le comportement natif.
   */
  function initVisibility() {
    var st = sticky();
    if (!st || !('IntersectionObserver' in window)) return;
    var formId = st.getAttribute('main-product-form');
    var form = formId && document.getElementById(formId);
    if (!form) return;
    var footer = document.querySelector('.shopify-section--footer');

    var formIn = false;
    var footerIn = false;
    var apply = function () {
      st.classList.toggle('sticky-cta-out', !formIn && !footerIn);
    };

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.target === form) formIn = e.isIntersecting;
        else if (e.target === footer) footerIn = e.isIntersecting;
      });
      apply();
    });
    io.observe(form);
    if (footer) io.observe(footer);
  }

  // --- Bouton « Ajouter au panier » mobile : réduit la police pour tenir sur 1 ligne ---
  function fitAddButton() {
    if (!isMobile()) return;
    var st = sticky();
    if (!st) return;
    var btn = st.querySelector('.sticky-atc-mobile__add');
    if (!btn) return;
    btn.style.fontSize = ''; // repart de la taille CSS
    var size = parseFloat(window.getComputedStyle(btn).fontSize);
    var guard = 0;
    // .sticky-atc-mobile__add est en white-space:nowrap → scrollWidth = largeur 1 ligne
    while (btn.scrollWidth > btn.clientWidth + 1 && size > 9 && guard < 40) {
      size -= 0.5;
      btn.style.fontSize = size + 'px';
      guard++;
    }
  }

  function initFit() {
    fitAddButton();
    window.addEventListener('resize', fitAddButton);
    window.addEventListener('load', fitAddButton);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitAddButton);
    }
    var st = sticky();
    if (st && 'MutationObserver' in window) {
      // re-render du prix (changement de variante) → re-ajuste
      new MutationObserver(fitAddButton).observe(st, { childList: true, subtree: true });
    }
  }

  initVisibility();
  initFit();
})();
